module.exports = __webpack_public_path__ + "img/icon-phone@2x.be98173b.png";